$(document).foundation();
$(document).ready(function () {
	// utils
	inlineSVGs([
		'.header__logo-group img'
	]);
	initAnimateInView();
	initVerticalCenter();
	
	// global
	initPopup();
	initOffCanvas();
	initHeader();
	initFooter();
	initSliders();
	initExplore();
	initEditDetailExplore();
	initAccommodation();
	initAccommodationGallery();
	initFoodDrinkGallery();
	initFoodDrink();
	initEvents();
	initScrollBars();
	initEditDetailGallery();
	initNewsletterPopup();
	initAnchors();
	
	// template specific
	initContact();
	initStandardContent();
	initEditListing();
	initGallery();
});

function initGallery() {
	$('.gallery__item').on('mouseenter', function() {
		$(this).find('.gallery__item-overlay').addClass('active');
	})

	$('.gallery__item').on('mouseleave', function() {
		$(this).find('.gallery__item-overlay').removeClass('active');
	})

	$('.gallery__item a').on('click', function () {
		var $clickedThumbnail = $(this);
		
		// Dynamically load the gallery slider into a reveal popup	
		var modal = '<div id="gallery__modal" class="gallery__modal full reveal loading" data-reveal><div class="gallery__modal-image"><button class="gallery__modal-close" data-close aria-label="Close modal" type="button"><span aria-hidden="true">Close</span></button><img src="{{src}}"><button class="gallery__modal-prev">Previous</button><button class="gallery__modal-next">Next</button></div><div class="gallery__modal-content grid-x"><div class="gallery__modal-caption cell small-12 medium-6 medium-offset-3">{{caption}}</div></div></div>';
		
		modal = modal.replace('{{src}}', $(this).attr('href'));
		modal = modal.replace('{{caption}}', $(this).data('title') || '');

		
		var $modal = modal;
		
		$('body').append($modal);
		
		$('#gallery__modal').foundation().on('closed.zf.reveal', function () {
			$('#gallery__modal').remove();
		});
		
		$('#gallery__modal').foundation('open');
		
		$('.gallery__modal-next').on('click', function () {
			$('#gallery__modal').foundation('close');
			$('#gallery__modal').remove();
			if ( $clickedThumbnail.parent().next(':visible').length > 0 ) { // is the next thumb visible?
				$clickedThumbnail.parent().next(':visible').find('a').trigger('click');
			} else if ( $clickedThumbnail.parent().nextUntil(':visible').length > 0 ) { // no, so find the next visible one
				$clickedThumbnail.parent().nextAll(':visible').first().find('a').trigger('click');
				$('#gallery__modal').foundation('close');
				$('#gallery__modal').remove();
			}
		});
		
		$('.gallery__modal-prev').on('click', function () {
			$('#gallery__modal').foundation('close');
			$('#gallery__modal').remove();
			if ( $clickedThumbnail.parent().prev(':visible').length > 0 ) { // is the previous thumb visible?
				$clickedThumbnail.parent().prev(':visible').find('a').trigger('click');
			} else if ( $clickedThumbnail.parent().prevUntil(':visible').length > 0 ) { // no, so find the next visible one that comes before this
				$clickedThumbnail.parent().prevAll(':visible').last().find('a').trigger('click');
				$('#gallery__modal').foundation('close');
				$('#gallery__modal').remove();
			}
		});
		
		return false;
	});
}

// https://stackoverflow.com/questions/24933430/img-src-svg-changing-the-fill-color
function inlineSVGs(inputValue) {
	var selectorString = '';
	if (typeof inputValue === "object") {
		selectorString = inputValue.join(',');
	} else {
		selectorString = inputValue;
	}

	$(selectorString).each(function () {
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');
		
		if (imgURL.indexOf('.svg') > -1) {
			$.get(imgURL, function (data) {
				// Get the SVG tag, ignore the rest
				var $svg = $(data).find('svg');
	
				// Add replaced image's ID to the new SVG
				if (typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if (typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass + ' replaced-svg');
				}
	
				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');
	
				// Check if the viewport is set, if the viewport is not set the SVG wont't scale.
				if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
					$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
				}
	
				// Replace image with new SVG
				$img.replaceWith($svg);
			}, 'xml');
		}
	});
}

function initPopup() {
	if ($('#popup').length > 0) {
		var popupDelay = $('#popup').data('popup-delay') || 0;
		var popupKeepHiddenFor = $('#popup').data('popup-keep-hidden-for-n-days') || 0;

		// Only show the popup if the cookie has not been seen, or always show it for testing in either local or remote markup
		if ( 
			(!Cookies.get('hasSeenPopup')) || 
			(location.hostname.indexOf('localhost') > -1) || 
			(location.hostname.indexOf('projects') > -1) 
		) {
			setTimeout(function() {
				$('#popup').foundation('open');

				if (popupKeepHiddenFor > 0) {
					Cookies.set('hasSeenPopup', 'true', { expires: popupKeepHiddenFor });
				}
			}, popupDelay);
		}
	}
}

function initNewsletterPopup() {
	$('a[href="#open-newsletter"]').on('click', function(e) {
		e.preventDefault();
		$('#newsletter').foundation('open');
	})

	var selectAllButton = $('.newsletter__form-all-locations');
	selectAllButton.on('click', function() {

		if ($(this).hasClass('on')) {
			$(this).removeClass('on');
			$('.newsletter__form-checkbox input[type="checkbox"]').prop( "checked", false );
		} else {
			$(this).addClass('on');
			$('.newsletter__form-checkbox input[type="checkbox"]').prop( "checked", true );
		}
	})
}


function initOffCanvas() {
	//$('#offCanvas').foundation('open');
	
	// Open the sub menu when hovering over any sub-menu-opening links
	$('[data-open-sub-menu]').on('mouseenter', function () {
		// Close any previously open sub menus and link states
		$('.current-link').removeClass('current-link');
		$(this).addClass('current-link');
		$('.off-canvas__main').addClass('sub-menu-open');
		$('.off-canvas__sub').removeClass('is-open');
		
		// Find the right sub menu and open it
		$('.off-canvas__sub[data-sub-menu="' + $(this).data('open-sub-menu') + '"]').addClass('is-open');
		
		// Lazy load The Edit images to speed up pages
		if ($(this).data('open-sub-menu') === 'the-edit') {
			$('.off-canvas__sub[data-sub-menu="the-edit"]').find('a[data-img]').each(function () {
				if ( $(this).find('img').length === 0 ) {
					$(this).prepend('<img src="' + $(this).data('img') + '">');
				}
			});
		}
	});

	if( $(window).outerWidth() < 1024  ) {
		$('[data-open-sub-menu]').on('click', function (e) {
			if( $(this).hasClass('sub-open') ) {
				return true;
			} else {
				e.preventDefault();
				$('.sub-open').each(function() {
					$(this).removeClass('sub-open');
				})
				$(this).addClass('sub-open');
			}
		})
	}
	
	// Close any sub menu when hovering over a non-submenu-opening link
	$('.off-canvas__main a, .off-canvas__close').not('[data-open-sub-menu]').on('mouseenter', function () {
		$('.current-link').removeClass('current-link');
		$('.off-canvas__main').removeClass('sub-menu-open');
		$('.off-canvas__sub').removeClass('is-open');
	});
	
	// Show/hide the section image when hovering over the sub menu links
	$('.off-canvas__sub-image').each(function () {
		$(this).attr('src', $(this).data('src') );
	});
	
	$('[data-img]')
		.on('mouseenter', function () {
			var $img = $(this).parents('.off-canvas__sub').find('.off-canvas__sub-image');
			$img.attr('src', $(this).data('img'));
		})
		.on('mouseleave', function () {
			var $img = $(this).parents('.off-canvas__sub').find('.off-canvas__sub-image');
			$img.attr('src', $img.data('src'));
		});
}


function initHeader() {
	
	function throttle(fn, threshhold, scope) {
	  threshhold || (threshhold = 250);
	  var last,
		  deferTimer;
	  return function () {
		var context = scope || this;
	
		var now = +new Date,
			args = arguments;
		if (last && now < last + threshhold) {
		  // hold on to it
		  clearTimeout(deferTimer);
		  deferTimer = setTimeout(function () {
			last = now;
			fn.apply(context, args);
		  }, threshhold);
		} else {
		  last = now;
		  fn.apply(context, args);
		}
	  };
	}

	// Detect if the header is over and image slider, if yes then give it a transparent background

	if($('.slider__video').length > 0) return
	setHeaderTransparency();
	$(window).on('scroll', setHeaderTransparency);

	function setHeaderTransparency() {
		if (window.pageYOffset > (window.innerHeight / 5) ) {
			$('.header').removeClass('header--transparent').addClass('header--compact');

			if ( $('body').hasClass('property') ) {
				$('.header__property-booking-bar').addClass('active');
			}
		} else {
			$('.header').removeClass('header--compact');

			if ( $('body').hasClass('property') ) {
				$('.header__property-booking-bar').removeClass('active');
			}
			if ( ($('.slider').length < 1) && ($('body').hasClass('group')) ) {
				$('body').addClass('no-slider');
			}
			if ( ($('body').hasClass('group')) && (!$('body').hasClass('no-slider')) ) {
				$('.header').addClass('header--transparent');
			} else {
			}
		}
	}

	$('.header__nav-mobile').accordiom({
		showFirstItem: false
	});

	$('.header__nav-mobile-trigger button').on('click', function() {
		$(this).toggleClass('open');
		$('.header__nav-mobile .accordionButton').trigger('click');
	});

	// only on map filter page
	function setMainBasedOnNav () {
	
		if (window.innerWidth <= 640 || $('.area-map').length === 0) return

		var linksH = $('.header__nav ul').height()
		var main = $('main')
	
		if (linksH < 45) {
			main.css('padding-top', '201px')
			return
		}
		main.css('padding-top', '225px')
	}

	setMainBasedOnNav()
	$(window).on('resize', function () {
		setMainBasedOnNav()
	})

}

function initVerticalCenter() {
    $('.vertical-center').each(function () {
        $(this).wrapInner('<div class="vertical-center-table"><div class="vertical-center-row"><div class="vertical-center-cell"></div></div></div>');
    });
}


function initFooter() {
	if ( window.innerWidth <= 1024 ) {
		// Empty items for when the content needs to pull offscreen
		$('.footer__hotels-inner').prepend('<div class="footer__hotel"></div>'); 
		$('.footer__hotels-inner').append('<div class="footer__hotel"></div>');
	}
	
	$('.footer__hotels-inner').slick({
		slidesToShow: 5,
		arrows: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3
				}
			}
		]
	});
}

function initSliders() {
	

	if ($('.slider--full-height').length > 0) {
		$('main').addClass('no-header-padding');
	}

	var propertyPageWithSliderAndIntro = $('.slider--full-height').length > 0 && $('body').hasClass('property') && $('.intro').length > 0
	if (propertyPageWithSliderAndIntro) {
		$('main').removeClass('no-header-padding');
	}
	
	$('.slider__inner').reformSlider({
		speed: 3500,
		animationSpeed: 750,
		arrows: false,
		pagination: false,
		paginationArrows: false
	});
		
	if ($('.slider__video').length > 0) {
		console.log('hello')
		// Make sure the slider always fills the whole screen
		coverViewport($('.slider__video iframe'), true);
		$(window).on('resize', function () {
			coverViewport($('.slider__video iframe'), true);
		});
	}

	$('.explore__main-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		responsive: [
			{
				breakpoint: 640,
			  	settings: {
					slidesToShow: 1,
					centerMode: true,
					centerPadding: '15px',
					arrows: true
			  	}
			}
		]
	})

	$('.explore__small-slider, .edit-detail-explore__slider').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		responsive: [
			{
				breakpoint: 640,
			  	settings: {
					slidesToShow: 2,
					centerMode: true,
					centerPadding: '15px',
					arrows: true
			  	}
			}
		]
	})

	$('.events__item-slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: false
	})
	
	$('.events__item-slider img').on('click', function () {
		$(this).parents('.events__item-slider').slick('slickNext');
	})

	$('.events__item-slider-slide-info-title-floor').on('click', function(e) {
		e.preventDefault();
		$(this).parents('.events__item-slider-wrap').find('.events__item-slider').slick('slickGoTo', $(this).data('slide'))
		$(this).toggleClass('show');
		$(this).siblings().toggleClass('show');
	})

	$('.events__item-slider-slide-info-title-gallery').on('click', function(e) {
		e.preventDefault();
		$(this).parents('.events__item-slider-wrap').find('.events__item-slider').slick('slickGoTo', $(this).data('slide'))
		$(this).toggleClass('show');
		$(this).siblings().toggleClass('show');
	})

	// $('.accommodation__horizontal').slick({
	// 	slidesToShow: 2,
	// 	slidesToScroll: 1,
	// 	infinite: true,
	// 	arrows: true,
	// 	dots: false,
	// 	responsive: [
	// 		{
	// 			breakpoint: 640,
	// 		  	settings: {
	// 				slidesToShow: 1,
	// 		  	}
	// 		}
	// 	]
	// })

	if ( $('.accommodation').length > 0 ) {

		var container = $('.accommodation__horizontal');
		var prevArrow = $('.accommodation__horizontal-arrow-prev');
		var nextArrow = $('.accommodation__horizontal-arrow-next');
		var itemWidth = $('.accommodation__horizontal-item').outerWidth();
		
		prevArrow.on('click', function() {
			var offsetLeft = $('.accommodation__horizontal').scrollLeft();
			offsetLeft = offsetLeft - itemWidth;
			container.animate({
				scrollLeft: offsetLeft
			})
		});
		
		nextArrow.on('click', function() {
			var offsetLeft = $('.accommodation__horizontal').scrollLeft();
			offsetLeft = offsetLeft + itemWidth;
			container.animate({
				scrollLeft: offsetLeft
			})
		});

		$('.accommodation__filters .button').on('click', function() {
			if( $(this).hasClass('all') && $('.accommodation__horizontal-item').length > 1 ) {
				$('.accommodation__horizontal-arrow').show();
			} else {
				if( ($('.accommodation__horizontal-item.active').length * itemWidth) > container.outerWidth() ) {
					$('.accommodation__horizontal-arrow').show();
				} else {
					$('.accommodation__horizontal-arrow').hide();
				}
			}
		})
	}

	$('.food-drink-gallery__horizontal').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		responsive: [
			{
				breakpoint: 640,
			  	settings: {
					slidesToShow: 1,
			  	}
			}
		]
	})

	

	$('.food-drink__horizontal').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		responsive: [
			{
				breakpoint: 640,
			  	settings: {
					slidesToShow: 1,
			  	}
			}
		]
	})
	if ($('.food-drink__horizontal-item').length < 3) {
		$('.food-drink__horizontal .slick-list').attr('style', 'padding-right: 0px !important')
	}



	$('.offers__item-inner').slick({
		slidesToShow: 1,
		infinite: true,
		arrows: true
	})
	
	$('.slider__scroll').on('click', function () {
		$('html,body').animate({
			scrollTop: window.innerHeight
		}, 1000);
	});
}

function coverViewport(element, scaleToParent) {
    if (typeof scaleToParent === 'undefined') { scaleToParent = false; }

    var viewportWidth, viewportHeight;
    if (scaleToParent) {
        viewportWidth = $(element).parent().innerWidth();
        viewportHeight = $(element).parent().innerHeight();
    } else {
        viewportWidth = $(window).innerWidth();
        viewportHeight = $(window).innerHeight();
    }

    var $element = $(element);

    var elementWidth = $element.attr('width');
    var elementHeight = $element.attr('height');

    // Aspect ratio = height / width
    var viewportRatio = viewportHeight / viewportWidth;
    var videoRatio = elementHeight / elementWidth;

    //console.log('Viewport: ', viewportRatio, ' Video: ', videoRatio);


    var newWidth = (elementWidth / elementHeight) * viewportHeight
    var newHeight = (elementHeight / elementWidth) * viewportWidth;
    var newTop = 0;

    if (viewportRatio > videoRatio) {
        // set video height to the viewport, and extend the video beyond the viewport width, i.e. portrait viewport
        //console.log('crop left and right');
        $element.css('height', viewportHeight);
        $element.css('width', newWidth);
        $element.css('left', '-' + (newWidth - viewportWidth) / 2 + 'px');
        $element.css('top', '0');
    } else if (viewportRatio < videoRatio) {
        // set video width to the viewport, and extend the video beyond the viewport height, i.e. landscape viewport
        //console.log('crop top and bottom');
        $element.css('width', viewportWidth);
        $element.css('height', newHeight);
        $element.css('left', '0');
        $element.css('top', '-' + (newHeight - viewportHeight) / 2 + 'px');
    } else {
        // set the video width AND height to the viewport size, i.e. viewport is the same ratio as the video
        //console.log('no crop');
        $element.css('height', viewportHeight);
        $element.css('width', viewportWidth);
        $element.css('left', '0');
        $element.css('top', '0');
    }
}

function initAnimateInView() {

	$(window).on('DOMContentLoaded load resize scroll', animateElementsInView);
	animateElementsInView();
	
	function animateElementsInView() {
		$('[data-animate-in-view]').each(function () {
			if ( isElementInViewport($(this)) ) {
				$(this).addClass( $(this).data('animate-in-view') );
			}
		});
	}
	
	// Modified version of:
	// https://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
	function isElementInViewport (el) {
	    //special bonus for those using jQuery
	    if (typeof jQuery === "function" && el instanceof jQuery) {
	        el = el[0];
	    }
	
	    var rect = el.getBoundingClientRect();
	    
	    return (
		    rect.top <=  $(window).scrollTop() + window.innerHeight
	    );
	}
}

function initExplore() {
	$('.explore__main-slider-slide').on('mouseenter', function() {
		$(this).find('.explore__main-slider-image-overlay').addClass('on');
	});

	$('.explore__main-slider-slide').on('mouseleave', function() {
		$(this).find('.explore__main-slider-image-overlay').removeClass('on');
	});

	$('.explore__main-slider-arrows').on('click', function() {
		$('.explore__main-slider .slick-next').trigger('click');
	})

	$('.explore__small-slider-arrows').on('click', function() {
		$('.explore__small-slider .slick-next').trigger('click');
	})
}

function initEditDetailExplore() {
	$('.edit-detail-explore__small-slider-slide').on('mouseenter', function() {
		$(this).find('.edit-detail-explore__small-slider-image-overlay').addClass('on');
	});

	$('.edit-detail-explore__small-slider-slide').on('mouseleave', function() {
		$(this).find('.edit-detail-explore__small-slider-image-overlay').removeClass('on');
	});

	$('.edit-detail-explore__small-slider-arrows').on('click', function() {
		$('.edit-detail-explore__small-slider .slick-next').trigger('click');
	})
}

function initAccommodation() {
	// Jump to the first visible item when filtering accommodation slider
	$('.accommodation__inner-wrap').on('filter-changed', function () {
		setTimeout(function () {
			$('.accommodation__horizontal').slick('slickGoTo', $('.accommodation__inner-wrap .active').first().parents('.slick-slide').data('slick-index'));
		}, 300);
	});
	
	
	/*$('.accommodation__inner-wrap').on('filter-changed', function () {
		console.log('---');
		setTimeout(function () {
			$('.accommodation__horizontal').slick('slickFilter', function (index) {
				//console.log( $(this).find('.accommodation__horizontal-item') )
				//if ( $(this).find('.accommodation__horizontal-item').is(':visible') ) {
				if ( $(this).find('.accommodation__horizontal-item').attr('style').indexOf('none') > -1 ) {
					console.log('is visible');
					return false;
				} else {
					console.log('not visible');
					return true;
				}
			});
		}, 600);
		//$('.filtering').slick('slickUnfilter');
	});*/
	
	/*$('.accommodation__horizontal-item').on('mouseenter', function() {
		$(this).find('.accommodation__horizontal-item-image-overlay').addClass('on');
	});

	$('.accommodation__horizontal-item').on('mouseleave', function() {
		$(this).find('.accommodation__horizontal-item-image-overlay').removeClass('on');
	});

	if( $(window).outerWidth() > 640) {
		if ( $('.accommodation__horizontal-item').length > 2 ) {
			$('.accommodation__horizontal-wrap').append('<button class="scroll-button">scroll</button>');
		} else {
			$('.accommodation__horizontal-wrap.scroll').remove('.scroll-button');
		}
	} else {
		if ( $('.accommodation__horizontal-item').length > 1 ) {
			$('.accommodation__horizontal-wrap').append('<button class="scroll-button">scroll</button>');
		} else {
			$('.accommodation__horizontal-wrap.scroll').remove('.scroll-button');
		}
	}

	$('.accommodation__filters button').on('click', function() {
		setTimeout(function() {
			if( $(window).outerWidth() >= 640) {
				if ( $('.accommodation__horizontal-item.active').length > 2 ) {
					$('.scroll-button').css('display', 'block');
				} else {
					$('.scroll-button').css('display', 'none');
				}
			} else {
				if ( $('.accommodation__horizontal-item.active').length > 1 ) {
					$('.scroll-button').css('display', 'block');
				} else {
					$('.scroll-button').css('display', 'none');
				}
			}
		},200);
	});

	$('.accommodation__horizontal').scroll(function () {
		var scrollLocation = $('.accommodation__horizontal');
		var newScrollLeft = scrollLocation.scrollLeft(),
			width = scrollLocation.width(),
			scrollWidth = scrollLocation.get(0).scrollWidth;
		var offset = 0;
		if (scrollWidth - newScrollLeft - width === offset) {
			$('.scroll-button').css('display', 'none');
		}
		if (newScrollLeft === 0) {
			$('.scroll-button').css('display', 'block');
		}
	});

	$('.accommodation__horizontal').scrollLeft(1);
	$('.accommodation__horizontal').scrollLeft(0);

	$('.accommodation__horizontal-wrap .scroll-button').on('click', function() {
		$('.accommodation__horizontal').animate({
			scrollLeft: '+=300'
		}, 'slow');
	})

	var clicked = false, base = 0;

	$('.accommodation__horizontal-wrap').on({
		mousemove: function(e) {
			clicked && function(xAxis) {
				var _this = $(this);
				if(base > xAxis) {
					base = xAxis;
					_this.css('margin-left', '-=1px');
				}
				if(base < xAxis) {
					base = xAxis;
					_this.css('margin-left', '+=1px');
				}
			}.call($(this), e.pageX);
		},
		mousedown: function(e) {
			e.preventDefault();
			clicked = true;
			base = e.pageX;
		},
		mouseup: function(e) {
			e.preventDefault();
			clicked = false;
			base = 0;
		}
	});*/
	
	
}

function initAccommodationGallery() {

	if( $(window).outerWidth() > 640) {
		if ( $('.accommodation-gallery__horizontal-item').length > 2 ) {
			$('.accommodation-gallery__horizontal-wrap').append('<button class="scroller">scroll</button>');
		} else {
			$('.accommodation-gallery__horizontal-wrap.scroll').remove('.scroller');
		}
	} else {
		if ( $('.accommodation-gallery__horizontal-item').length > 1 ) {
			$('.accommodation-gallery__horizontal-wrap').append('<button class="scroller">scroll</button>');
		} else {
			$('.accommodation-gallery__horizontal-wrap.scroll').remove('.scroller');
		}
	}

	// $('.accommodation-gallery__horizontal').scroll(function () {
	// 	var scrollLocation = $('.accommodation-gallery__horizontal');
	// 	var newScrollLeft = scrollLocation.scrollLeft(),
	// 		width = scrollLocation.width(),
	// 		scrollWidth = scrollLocation.get(0).scrollWidth;
	// 	var offset = 0;

	// 	if (scrollWidth - newScrollLeft - width === offset) {
	// 		$('.scroller').css('display', 'none');
	// 	}
	// 	if (newScrollLeft === 0) {
	// 		$('.scroller').css('display', 'block');
	// 	}
	// });

	// $('.accommodation-gallery__horizontal').scrollLeft(1);
	// $('.accommodation-gallery__horizontal').scrollLeft(0);

	// $('.accommodation-gallery__horizontal-wrap .scroller').on('click', function() {
	// 	if ( $(window).outerWidth() >= 640 && $(window).outerWidth() < 1024 ) {
	// 		$('.accommodation-gallery__horizontal').animate({
	// 			scrollLeft: '+=500'
	// 		}, 'slow');
	// 		console.log('scroll 500');
	// 	} else if ( $(window).outerWidth() >= 1024 ) {
	// 		$('.accommodation-gallery__horizontal').animate({
	// 			scrollLeft: '+=1000'
	// 		}, 'slow');
	// 		console.log('scroll 1000');
	// 	} else {
	// 		$('.accommodation-gallery__horizontal').animate({
	// 			scrollLeft: '+=200'
	// 		}, 'slow');
	// 		console.log('scroll 200');
	// 	}
	// });

	$('.accommodation-gallery__horizontal').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		asNavFor: '.accommodation-gallery__horizontal-item-count'
	})

	$('.accommodation-gallery__horizontal-item-count').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		asNavFor: '.accommodation-gallery__horizontal'
	})

	// $('.accommodation-gallery__horizontal-item button').on('click', function () {
	// 	var $clickedThumbnail = $(this);
	// 	// Dynamically load the gallery slider into a reveal popup	
	// 	var modal = '<div id="accommodation-gallery__modal" class="accommodation-gallery__modal full reveal loading" data-reveal><div class="accommodation-gallery__modal-wrap"><div class="accommodation-gallery__modal-image "><button class="accommodation-gallery__modal-close" data-close aria-label="Close modal" type="button"><span aria-hidden="true">Close</span></button><img src="{{src}}"><button class="accommodation-gallery__modal-prev">Previous</button><button class="accommodation-gallery__modal-next">Next</button></div></div></div>';
		
	// 	modal = modal.replace('{{src}}', $(this).data('link'));
	// 	var $modal = modal;
		
	// 	$('body').append($modal);
		
	// 	$('#accommodation-gallery__modal').foundation().on('closed.zf.reveal', function () {
	// 		$('#accommodation-gallery__modal').remove();
	// 	});
		
	// 	$('#accommodation-gallery__modal').foundation('open');

	// 	$('.accommodation-gallery__modal-next').on('click', function () {
	// 		$('#accommodation-gallery__modal').foundation('close');
	// 		$('#accommodation-gallery__modal').remove();
	// 		if ( $clickedThumbnail.parent().next(':visible').length > 0 ) { // is the next thumb visible?
	// 			$clickedThumbnail.parent().next(':visible').find('a').trigger('click');
	// 		} else if ( $clickedThumbnail.parent().nextUntil(':visible').length > 0 ) { // no, so find the next visible one
	// 			$clickedThumbnail.parent().nextAll(':visible').first().find('a').trigger('click');
	// 			$('#accommodation-gallery__modal').foundation('close');
	// 			$('#accommodation-gallery__modal').remove();
	// 		}
	// 	});
		
	// 	$('.accommodation-gallery__modal-prev').on('click', function () {
	// 		$('#accommodation-gallery__modal').foundation('close');
	// 		$('#accommodation-gallery__modal').remove();
	// 		if ( $clickedThumbnail.parent().prev(':visible').length > 0 ) { // is the previous thumb visible?
	// 			$clickedThumbnail.parent().prev(':visible').find('a').trigger('click');
	// 		} else if ( $clickedThumbnail.parent().prevUntil(':visible').length > 0 ) { // no, so find the next visible one that comes before this
	// 			$clickedThumbnail.parent().prevAll(':visible').last().find('a').trigger('click');
	// 			$('#accommodation-gallery__modal').foundation('close');
	// 			$('#accommodation-gallery__modal').remove();
	// 		}
	// 	});

	// 	return false;
	// });


	$('[data-gallery]').on('click', function () {
		//var activeSlideIndex = $(this).data('slide-index') || $(this).next().find('.slick-active').index();

		var activeSlideIndex = $(this).index() || 0;

		$('.accommodation-gallery-popup__inner')
		.empty()
		.load($(this).data('gallery'), function () {
			$('.accommodation-gallery-popup .accommodation-gallery__modal').slick({
				initialSlide: Math.max(activeSlideIndex -1, 0),
				arrows: true,
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
			});
		});
		$('.accommodation-gallery-popup').foundation('open');
	});
	
	
	if ($('.gallery').length > 0) {
		showCurrentGallery();
		$('#gallery-tabs').on('change.zf.tabs', showCurrentGallery);
	}

}

function showCurrentGallery() {
	
	$slider = $('.gallery .is-active .gallery__slider');

	if ( $slider.length > 0 ) {
		if (!$slider.hasClass('slick-initialized')) {
			// lazy load the images on tab change
			$slider.find('img').each(function () {
				if ( typeof $(this).data('src') !== 'undefined' ) {
					$(this).attr('src', $(this).data('src'));
					$(this).removeAttr('data-src');
				}
			});
			
			// then init the gallery slider
			$slider.slick({
				fade: true,
				arrows: true
			});
		}
	} else {
		$('.gallery .is-active iframe').each(function () {
			$(this).attr('src', $(this).data('src'));
		});
	}
}

function initFoodDrink() {
	$('.food-drink__horizontal-item').on('mouseenter', function() {
		$(this).find('.food-drink__horizontal-item-image-overlay').addClass('on');
	});

	$('.food-drink__horizontal-item').on('mouseleave', function() {
		$(this).find('.food-drink__horizontal-item-image-overlay').removeClass('on');
	});

	if( $(window).outerWidth() > 640) {
		if ( $('.food-drink__horizontal-item').length > 2 ) {
			$('.food-drink__horizontal-wrap').append('<button class="scroll-button">scroll</button>');
		} else {
			$('.food-drink__horizontal-wrap.scroll').remove('.scroll-button');
		}
	} else {
		if ( $('.food-drink__horizontal-item').length > 1 ) {
			$('.food-drink__horizontal-wrap').append('<button class="scroll-button">scroll</button>');
		} else {
			$('.food-drink__horizontal-wrap.scroll').remove('.scroll-button');
		}
	}

	$('.food-drink__horizontal').scroll(function () {
		var scrollLocation = $('.food-drink__horizontal');
		var newScrollLeft = scrollLocation.scrollLeft(),
			width = scrollLocation.width(),
			scrollWidth = scrollLocation.get(0).scrollWidth;
		var offset = 0;
		if (scrollWidth - newScrollLeft - width === offset) {
			$('.scroll-button').css('display', 'none');
		}
		if (newScrollLeft === 0) {
			$('.scroll-button').css('display', 'block');
		}
	});

	$('.food-drink__horizontal').scrollLeft(1);
	$('.food-drink__horizontal').scrollLeft(0);

	$('.food-drink__horizontal-wrap .scroll-button').on('click', function() {
		$('.food-drink__horizontal').animate({
			scrollLeft: '+=300'
		}, 'slow');
	})
}

function initFoodDrinkGallery() {

	if( $(window).outerWidth() > 640) {
		if ( $('.food-drink-gallery__horizontal-item').length > 2 ) {
			$('.food-drink-gallery__horizontal-wrap').append('<button class="scroller">scroll</button>');
		} else {
			$('.food-drink-gallery__horizontal-wrap.scroll').remove('.scroller');
		}
	} else {
		if ( $('.food-drink-gallery__horizontal-item').length > 1 ) {
			$('.food-drink-gallery__horizontal-wrap').append('<button class="scroller">scroll</button>');
		} else {
			$('.food-drink-gallery__horizontal-wrap.scroll').remove('.scroller');
		}
	}

	$('.food-drink-gallery__horizontal').scroll(function () {
		var scrollLocation = $('.food-drink-gallery__horizontal');
		var newScrollLeft = scrollLocation.scrollLeft(),
			width = scrollLocation.width(),
			scrollWidth = scrollLocation.get(0).scrollWidth;
		var offset = 0;

		if (scrollWidth - newScrollLeft - width === offset) {
			$('.scroller').css('display', 'none');
		}
		if (newScrollLeft === 0) {
			$('.scroller').css('display', 'block');
		}
	});

	$('.food-drink-gallery__horizontal').scrollLeft(1);
	$('.food-drink-gallery__horizontal').scrollLeft(0);

	$('.food-drink-gallery__horizontal-wrap .scroller').on('click', function() {
		if ( $(window).outerWidth() >= 640 && $(window).outerWidth() < 1024 ) {
			$('.food-drink-gallery__horizontal').animate({
				scrollLeft: '+=500'
			}, 'slow');
			console.log('scroll 500');
		} else if ( $(window).outerWidth() >= 1024 ) {
			$('.food-drink-gallery__horizontal').animate({
				scrollLeft: '+=1000'
			}, 'slow');
			console.log('scroll 1000');
		} else {
			$('.food-drink-gallery__horizontal').animate({
				scrollLeft: '+=200'
			}, 'slow');
			console.log('scroll 200');
		}
	});

	$('.food-drink-gallery__horizontal-item button').on('click', function () {
		var $clickedThumbnail = $(this);
		// Dynamically load the gallery slider into a reveal popup	
		var modal = '<div id="food-drink-gallery__modal" class="food-drink-gallery__modal full reveal loading" data-reveal><div class="food-drink-gallery__modal-wrap"><div class="food-drink-gallery__modal-image "><button class="food-drink-gallery__modal-close" data-close aria-label="Close modal" type="button"><span aria-hidden="true">Close</span></button><img src="{{src}}"></div></div></div>';
		
		modal = modal.replace('{{src}}', $(this).data('link'));
		var $modal = modal;
		
		$('body').append($modal);
		
		$('#food-drink-gallery__modal').foundation().on('closed.zf.reveal', function () {
			$('#food-drink-gallery__modal').remove();
		});
		
		$('#food-drink-gallery__modal').foundation('open');
		return false;
	});
}


function initEvents() {
	$('.events__item-slider-open').on('click', function () {
		var $clickedThumbnail = $(this);
		// Dynamically load the gallery slider into a reveal popup	
		var modal = '<div id="events__item-slider-modal" class="events__item-slider-modal full reveal loading" data-reveal><div class="events__item-slider-modal-wrap"><div class="events__item-slider-modal-image "><button class="events__item-slider-modal-close" data-close aria-label="Close modal" type="button"><span aria-hidden="true">Close</span></button><img src="{{src}}"></div></div></div>';
		
		modal = modal.replace('{{src}}', $(this).data('link'));
		var $modal = modal;
		
		$('body').append($modal);
		
		$('#events__item-slider-modal').foundation().on('closed.zf.reveal', function () {
			$('#events__item-slider-modal').remove();
		});
		
		$('#events__item-slider-modal').foundation('open');
		return false;
	});
}

//var osScrollbar;

function initScrollBars() {
	
	$('.off-canvas__main, .off-canvas__sub, .area-map__content').each(function () {
		var $scrollContainer = $(this);
		
		$(this).overlayScrollbars({
			scrollbars: {
				autoHide: 'move'
			},
			callbacks: {
				onInitialized: function(eventArgs) {
					setTimeout(function () {
						updateScrollStatus($scrollContainer);
					}, 100);
				},
				onScroll: function(eventArgs) {
					updateScrollStatus($scrollContainer);
				}
			}
		});
		
		
	});
	$('.off-canvas__main, .off-canvas__sub, .area-map__content')
	.prepend('<div class="scroll-button scroll-button--up"></div>')
	.prepend('<div class="scroll-button scroll-button--down"></div>')
	.prepend('<div class="scroll-button scroll-button--left"></div>')
	.prepend('<div class="scroll-button scroll-button--right"></div>');
	
	
	
	$('.scroll-button--up').on('click', function () {
		$(this).parent().find('.os-viewport').animate({
			scrollTop: $(this).parent().find('.os-viewport').scrollTop() - 200
		}, 300);
	});
	
	$('.scroll-button--down').on('click', function () {		
		$(this).parent().find('.os-viewport').animate({
			scrollTop: $(this).parent().find('.os-viewport').scrollTop() + 200
		}, 300);
	});
	
	$('.scroll-button--left').on('click', function () {		
		$(this).parent().find('.os-viewport').animate({
			scrollLeft: $(this).parent().find('.os-viewport').scrollLeft() - 200
		}, 300);
	});
	
	$('.scroll-button--right').on('click', function () {		
		$(this).parent().find('.os-viewport').animate({
			scrollLeft: $(this).parent().find('.os-viewport').scrollLeft() + 200
		}, 300);
	});
}

function updateScrollStatus($scrollContainer) {
	// Set classes so we know if we're at the limits in any scroll direction
	var scrollState = $scrollContainer.overlayScrollbars().scroll();
	
	//console.log( $scrollContainer );
	
	if ( scrollState.position.y === 0 ) {
		$scrollContainer.addClass('scroll-at-top');
	} else {
		$scrollContainer.removeClass('scroll-at-top');
	}
	
	if ( scrollState.position.y === scrollState.max.y ) {
		$scrollContainer.addClass('scroll-at-bottom');
	} else {
		$scrollContainer.removeClass('scroll-at-bottom');
	}
	
	
	if ( scrollState.position.x === 0 ) {
		$scrollContainer.addClass('scroll-at-left');
	} else {
		$scrollContainer.removeClass('scroll-at-left');
	}
	
	if ( scrollState.position.x === scrollState.max.x ) {
		$scrollContainer.addClass('scroll-at-right');
	} else {
		$scrollContainer.removeClass('scroll-at-right');
	}
}



function initContact() {
	if ( $('.contact__accordion .accordionButton').length > 1 ) {
		$('.contact__accordion').accordiom({
			showFirstItem: false,
			afterChange: function (accordionButton) {
				// Avoid loading the map until the item is opened
				buildMap( $(accordionButton).next('.accordionContent').find('[data-map-load-on-accordion-open]') );
			}
		});
		
		$('.open-on-load').trigger('click');
	} else {
		$('.accordionButton').addClass('no-clicky');
		buildMap( $('[data-map-load-on-accordion-open]') );
	}
}


function initStandardContent() {
	var totalImgs = $('.standard-content__slider img').length
	
	if ( totalImgs > 2 ) {
		$('.standard-content__slider-numbers').text( '1 / ' + totalImgs );
		
		$('.standard-content__slider').on('afterChange', function (event, slick, currentSlide) {
			$('.standard-content__slider-numbers').text( (currentSlide + 1) + ' / ' + totalImgs );
		});
	}
	
	$('.standard-content__slider').slick({
		slidesToShow: 2,
		arrows: true,
		swipeToSlide: true,
		responsive: [
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});
}

function initEditListing() {
	$('.edit-listing__filters').accordiom({
		showFirstItem: false
	})
	

	/*var listingCategories =  [];
	var listingItems = $('.edit-listing__grid-item');
	
	// get list of all items' categories
	listingItems.each(function() {
		var itemCategory = $(this).data('filter-categories');
		listingCategories.push(itemCategory);
	});
	
	categoryCounts = listingCategories.reduce(function (cc, lc) {
		cc[lc] = (cc[lc] || 0) + 1;
        return cc;
    }, Object.create(null));

	var catKeys = Object.keys(categoryCounts);
	var filterButtons = $('.edit-listing__filters a');

	catKeys.forEach(function(key, index) {

		filterButtons.each(function() {
			if( $(this).data('filter-category') == key ) {
				$(this).next().text('(' + categoryCounts[key] + ')');	
			}
		})
	})

	var totalItems = listingItems.length;
	$('.edit-listing__filters .all').next().text('(' + totalItems + ')');

	$('.edit-listing__filters-active-filter h4').text('filter-results: All');
	
	$('.edit-listing__filters a').on('click', function() {		
		// var activatedCat = $('.edit-listing__filters .active').data('filter-category');
		$('.edit-listing__filters-active-filter h4').text('filter-results: ' + $(this).text());
		$('.edit-listing__filters .accordionButton').trigger('click');
		return false;
	})*/
}

function initEditDetailGallery() {

	if( $(window).outerWidth() > 640) {
		if ( $('.edit-detail__horizontal-item').length > 2 ) {
			$('.edit-detail__horizontal-wrap').append('<button class="scroller">scroll</button>');
		} else {
			$('.edit-detail__horizontal-wrap.scroll').remove('.scroller');
		}
	} else {
		if ( $('.edit-detail__horizontal-item').length > 1 ) {
			$('.edit-detail__horizontal-wrap').append('<button class="scroller">scroll</button>');
		} else {
			$('.edit-detail__horizontal-wrap.scroll').remove('.scroller');
		}
	}

	// $('.edit-detail__horizontal').scroll(function () {
	// 	var scrollLocation = $('.edit-detail__horizontal');
	// 	var newScrollLeft = scrollLocation.scrollLeft(),
	// 		width = scrollLocation.width(),
	// 		scrollWidth = scrollLocation.get(0).scrollWidth;
	// 	var offset = 0;

	// 	if (scrollWidth - newScrollLeft - width === offset) {
	// 		$('.scroller').css('display', 'none');
	// 	}
	// 	if (newScrollLeft === 0) {
	// 		$('.scroller').css('display', 'block');
	// 	}
	// });

	// $('.edit-detail__horizontal').scrollLeft(1);
	// $('.edit-detail__horizontal').scrollLeft(0);

	// $('.edit-detail__horizontal-wrap .scroller').on('click', function() {
	// 	if ( $(window).outerWidth() >= 640 && $(window).outerWidth() < 1024 ) {
	// 		$('.edit-detail__horizontal').animate({
	// 			scrollLeft: '+=500'
	// 		}, 'slow');
	// 		console.log('scroll 500');
	// 	} else if ( $(window).outerWidth() >= 1024 ) {
	// 		$('.edit-detail__horizontal').animate({
	// 			scrollLeft: '+=1000'
	// 		}, 'slow');
	// 		console.log('scroll 1000');
	// 	} else {
	// 		$('.edit-detail__horizontal').animate({
	// 			scrollLeft: '+=200'
	// 		}, 'slow');
	// 		console.log('scroll 200');
	// 	}
	// });

	$('.edit-detail__horizontal').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		asNavFor: '.edit-detail__horizontal-item-count'
	})

	$('.edit-detail__horizontal-item-count').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		asNavFor: '.edit-detail__horizontal'
	})

	$('.edit-detail__horizontal-item button').on('click', function () {
		var $clickedThumbnail = $(this);
		// Dynamically load the gallery slider into a reveal popup	
		var modal = '<div id="edit-detail__modal" class="edit-detail__modal full reveal loading" data-reveal><div class="edit-detail__modal-wrap"><div class="edit-detail__modal-image "><button class="edit-detail__modal-close" data-close aria-label="Close modal" type="button"><span aria-hidden="true">Close</span></button><img src="{{src}}"></div></div></div>';
		
		modal = modal.replace('{{src}}', $(this).data('link'));
		var $modal = modal;
		
		$('body').append($modal);
		
		$('#edit-detail__modal').foundation().on('closed.zf.reveal', function () {
			$('#edit-detail__modal').remove();
		});
		
		$('#edit-detail__modal').foundation('open');
		return false;
	});
}

function pad(n, width, z) {
	z = z || '0';
	n = n + '';
	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}



function initAnchors() {
	// Specific rooms & suites anchor for the property homepage
	// Nicely scroll if deep linked to an anchor
	if ( window.location.hash !== '' ) {
		$('.anchors a[href="' + window.location.hash + '"]').trigger('click');
		
		$('[data-animate-in-view]').each(function () {
			$(this).addClass( $(this).data('animate-in-view') );
		});
		
		
		// "skip" is a special anchor to skip below any slider to get to the content		
		if ( (window.location.hash === '#rooms-suites') || (window.location.hash === '#apartments') ) {
			$('html, body').animate({
				scrollTop: window.innerHeight - $('.header').outerHeight()
			}, 0);
			
			return;	
		}
		
		var anchorName = window.location.hash.replace('#', '');
		anchorName = anchorName.replace('%20', ' ');
		if ( $('a[name="' + anchorName + '"]').length === 0 ) {
			return;
		}
		
		
		
		// Delay to allow for scrolling animations
		var waitForAnimations = 1500;
		
		setTimeout(function () {
			var scrollToPos = $('a[name="' + anchorName + '"]').first().parent().offset().top;
			
			if (typeof scrollToPos !== 'undefined') {
				scrollToPos -= $('.header').outerHeight();
				//scrollToPos += 100;
			
			
				$('html, body').animate({
					scrollTop: scrollToPos
				}, 0);
			}
		}, waitForAnimations);
	}
}

function initCaptcha(token) {
	$('.contact form').submit();
}